const STORAGE_PREFIX = 'mfe-ebotics:visibleColumns:';

/**
 * Normalize a saved column list: drop unknown keys, dedupe, cap length, fall back to defaults if empty.
 */
export function sanitizeVisibleColumns(saved, allowedKeysSet, defaultColumns, maxColumns = 10) {
  if (!Array.isArray(saved) || saved.length === 0) {
    return [...defaultColumns];
  }
  const seen = new Set();
  const out = [];
  for (const key of saved) {
    if (!allowedKeysSet.has(key) || seen.has(key)) continue;
    seen.add(key);
    out.push(key);
  }
  if (out.length === 0) {
    return [...defaultColumns];
  }
  return out.slice(0, maxColumns);
}

export function loadVisibleColumns(storageKey, allowedKeysSet, defaultColumns, maxColumns = 10) {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + storageKey);
    if (raw == null || raw === '') {
      return [...defaultColumns];
    }
    const parsed = JSON.parse(raw);
    return sanitizeVisibleColumns(parsed, allowedKeysSet, defaultColumns, maxColumns);
  } catch (e) {
    console.error('Failed to load column preferences:', e);
    return [...defaultColumns];
  }
}

export function persistVisibleColumns(storageKey, columns) {
  try {
    localStorage.setItem(STORAGE_PREFIX + storageKey, JSON.stringify(columns));
  } catch (e) {
    console.error('Failed to save column preferences:', e);
  }
}
